import styles from './locked-field-label.module.scss';

interface LockedFieldLabelProps {
  label: string;
}

export const LockedFieldLabel = ({ label }: LockedFieldLabelProps) => {
  return (
    <div className={styles.labelContainer}>
      <p className={styles.labelText}>{label}</p>
    </div>
  );
};
